import { render, staticRenderFns } from "./KitchenScene.vue?vue&type=template&id=10e9face&scoped=true&"
import script from "./KitchenScene.vue?vue&type=script&lang=js&"
export * from "./KitchenScene.vue?vue&type=script&lang=js&"
import style0 from "./KitchenScene.vue?vue&type=style&index=0&id=10e9face&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9face",
  null
  
)

export default component.exports